<mat-toolbar class="flex justify-between">
  <div class="flex bg-green-700 p-1 rounded">
    <img src="assets/icons/icon-72x72.png" class="h-8"/>
    <h2 class="bg-green-700 text-gray-50 px-2">Help</h2>
  </div>

  <div>
    <button mat-button color="primary" (click)="goToAddCall()">
      <mat-icon>add_circle</mat-icon> Abrir Chamado
    </button>

    <button mat-button (click)="logout()" color="warn">
      <mat-icon>exit_to_app</mat-icon>
    </button>
  </div>
</mat-toolbar>
